import { CopyText } from "@/components/CopyText";
import { ItemCard, ItemCardDetails } from "@/components/ItemCard";
import { ListContainer } from "@/components/layout/ListContainer";
import { type PrePlanningDetail } from "@repo/api";
import {
  type ButtonType,
  LightMode,
  defineSpaceIcon,
  laptopPencilIcon,
  linkOutIcon,
} from "@repo/skapa";
import { t } from "@repo/translation";
import { LocalizedDateAndTime, SimpleLabelField, useSettings } from "@repo/ui";
import { isDefined } from "@repo/utils";

import { useActiveProject } from "../project/ActiveProject";

const HomeProjectItem = ({ item }: { item: PrePlanningDetail }) => {
  const { gpc_integration } = useSettings();
  const { opportunity } = useActiveProject();

  const gpcEnabled = gpc_integration?.stores?.find(
    (unitId) => unitId === opportunity?.customerMeetingPointBuCode
  );

  const actions = [
    item.kreativScanUrl
      ? {
          id: `open-scan__${item.kreativScanUrl}`,
          text: t("action.open_in_kreativ"),
          title: t("action.open_in_kreativ"),
          type: "emphasised" as ButtonType,
          iconOnly: true,
          icon: linkOutIcon,
          onClick: () => {
            if (item.kreativScanUrl) {
              window.open(item.kreativScanUrl, "_blank");
            }
          },
        }
      : undefined,
    item.imaginationPlanningUrl
      ? {
          id: `open-imagination__${item.imaginationPlanningUrl}`,
          text: t("action.view_imagination"),
          title: t("action.view_imagination"),
          type: "emphasised" as ButtonType,
          iconOnly: true,
          icon: linkOutIcon,
          onClick: () => {
            if (item.imaginationPlanningUrl) {
              window.open(item.imaginationPlanningUrl, "_blank");
            }
          },
        }
      : undefined,
    item.gpcPlanUrl && gpcEnabled
      ? {
          id: `open-in-gpc__${item.gpcPlanUrl}`,
          text: t("action.open_in_gpc"),
          title: t("action.open_in_gpc"),
          type: "emphasised" as ButtonType,
          icon: laptopPencilIcon,
          onClick: () => {
            window.open(item.gpcPlanUrl, "_blank");
          },
        }
      : undefined,
  ].filter(isDefined);

  return (
    <ItemCard
      editable
      key={item.sourceId}
      image={item.teaserImageUrl}
      icon={item.planningType === "MEASUREMENT" ? defineSpaceIcon : undefined}
      details={
        <ItemCardDetails
          title={item.planningType}
          description={
            <SimpleLabelField
              small
              label={t("label.added_at")}
              value={<LocalizedDateAndTime date={item.sourceAddedAt ?? ""} />}
              color={LightMode.colourTextAndIcon2}
            />
          }
        />
      }
      actions={actions}
      addOn={<CopyText text={item.planCode ?? item.sourceId} />}
    />
  );
};

export const HomeProjectItemList = ({
  data,
}: {
  data?: PrePlanningDetail[];
}) => {
  return (
    <ListContainer>
      {data?.map((item) => (
        <HomeProjectItem
          key={`home-project-item-${item.sourceId}`}
          item={item}
        />
      ))}
    </ListContainer>
  );
};
